export default __webpack_public_path__ + "static/media/pexels-lisa-fotios-851213.47d32e60.jpg";